export const GET_WAREHOUSE_DETAILS = "GET_WAREHOUSE_DETAILS";